import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';
import { AsyncImage } from '../../../components/AsyncImage/AsyncImage';
import React from 'react';

interface ProductDetailDialogProps {
  currentProduct: any;
  setCurrentProduct: (any) => void;
}

export const ProductDetailDialog = ({
  currentProduct,
  setCurrentProduct
}: ProductDetailDialogProps) => {
  return (
    <Dialog maxWidth={'md'} fullWidth={true} open={currentProduct !== null}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {currentProduct?.productDescription}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={(e) => setCurrentProduct(null)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Box sx={{ width: 240 }}>
            <Swiper
              navigation
              modules={[Navigation, Scrollbar, A11y]}
              effect="flip"
              spaceBetween={50}
              slidesPerView={1}
            >
              {currentProduct?.galleries?.map((item) => (
                <SwiperSlide
                  style={{
                    width: '250px'
                  }}
                >
                  <AsyncImage
                    isPopUp={true}
                    w={250}
                    h={'50%' as any}
                    url={item.image}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
          <TableContainer>
            <Table sx={{ maxWidth: '100%' }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Attributes</TableCell>
                  <TableCell>Values</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentProduct?.productAttributes
                  ?.sort((a, b) =>
                    a.attribute?.name > b.attribute?.name ? 1 : -1
                  )
                  ?.map((row, index) => (
                    <TableRow
                      key={row?.attribute?.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell key={`cell-name-${index}-${row.id}-name`}>
                        {row?.attribute?.name}
                      </TableCell>
                      <TableCell key={`cell-value-${index}-${row.id}-value`}>
                        {row?.productAttributeValues

                          ?.map(
                            (productAttributeValue: any) =>
                              productAttributeValue.attributeValue.value
                          )
                          .join(',')}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={false} autoFocus onClick={(e) => {}}>
          {<CircularProgress size={6} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
